import { Trans } from '@lingui/react'
import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'
import { type FC } from 'react'

import { getDiscountForCurrentQuantity } from './utils/getDiscountForCurrentQuantity'
import './VolumePricingLabelQuantitySelection.scss'

type VolumePricingLabelQuantitySelectionProps = {
  value: number
  volumePricing: VolumeBasedPriceV1[]
}

const VolumePricingLabelQuantitySelection: FC<
  VolumePricingLabelQuantitySelectionProps
> = ({ value, volumePricing }) => {
  const { discount } = getDiscountForCurrentQuantity(value, volumePricing)
  if (discount) {
    return (
      <>
        <div className="rebranding m-select__quantity-label m-select__quantity-label--desktop">
          <span className="m-select__quantity-label__text">{`-${discount}%`}</span>
        </div>
        <div className="rebranding m-select__quantity-label m-select__quantity-label--mobile">
          <span className="m-select__quantity-label__text">
            <Trans
              id="volumePricing.quantity.percentage.saving"
              values={{ discount }}
            />
          </span>
        </div>
      </>
    )
  }

  return null
}

export default VolumePricingLabelQuantitySelection
